import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../_shared/shared.module';
import { MaintenanceMessageComponent } from './maintenance-message/maintenance-message.component';
import { MaintenanceComponent } from './maintenance.component';

@NgModule({
    declarations: [MaintenanceComponent, MaintenanceMessageComponent],
    exports: [MaintenanceMessageComponent],
    imports: [CommonModule, SharedModule],
})
export class MaintenanceModule {}
